export default "__VITE_ASSET__35kVYxlN__"